import { useState } from 'react';
import { api } from 'app/api/client';
import { IReportDownloadResponse } from '../types/Reports';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { TRootStackParamList } from 'app/types/navigation';
import { useQueryClient } from '@tanstack/react-query';

type ReportNavigationProp = NativeStackNavigationProp<TRootStackParamList>;

export const useReportDownload = () => {
  const navigation = useNavigation<ReportNavigationProp>();
  const queryClient = useQueryClient();
  const [isDownloading, setIsDownloading] = useState<string | null>(null);
  const [downloadError, setDownloadError] = useState<string | null>(null);

  const downloadAndViewReport = async (reportId: string, reportTitle: string) => {
    try {
      setIsDownloading(reportId);
      setDownloadError(null);
    
      const downloadUrl = `/patient/api/v1/telemonitoring-reports/${reportId}/download`;

      const data = await api.get<IReportDownloadResponse>(downloadUrl);

      navigation.navigate('PdfDocumentPage', {
        pdfUrl: data.signed_url
      });
      queryClient.invalidateQueries({
        queryKey: [["telemonitoring-reports", "list", "not_opened_by_patient"]]
      });
      
    } catch (error) {
      setDownloadError('Errore durante il download del report. Riprova più tardi.');
    } finally {
      setIsDownloading(null);
    }
  };

  return {
    downloadAndViewReport,
    isDownloading,
    downloadError,
  };
};
